module.exports = __webpack_public_path__ + "static/media/texture (39).1f6322d6.jpg";